import React from "react";
import DefaultCard from "./default-card";
import {loginUrl} from '../constants';

const PaymentsCard = ({ category, isGuest }) => (
  <DefaultCard
    category={{
      ...category,
      link: {
        ...category.link,
        href: isGuest
          ? loginUrl
          : category.link.href,
        defaultUrl:`/help/payments`,
      },
    }}
  />
);

export default PaymentsCard;